/**
 * @generated SignedSource<<b380ed384aae10f6ec48bf326e7c92c3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentLabelSelectorDropdownListItemOverflowFragment$data = {
  readonly defaultContentTypes: string;
  readonly id: string;
  readonly " $fragmentType": "ContentLabelSelectorDropdownListItemOverflowFragment";
};
export type ContentLabelSelectorDropdownListItemOverflowFragment$key = {
  readonly " $data"?: ContentLabelSelectorDropdownListItemOverflowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentLabelSelectorDropdownListItemOverflowFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentLabelSelectorDropdownListItemOverflowFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultContentTypes",
      "storageKey": null
    }
  ],
  "type": "ContentLabel",
  "abstractKey": null
};

(node as any).hash = "d1c17f158a421a29fcbc799d383fb1d8";

export default node;
